const trailingSlash = path => {
  // Add trailing slash, if needed and no params are present
  if (
    path.indexOf('?') === -1 &&
    typeof path.split('').pop() !== 'undefined' &&
    path.split('').pop() !== '/'
  ) {
    return '/'
  } else {
    return ''
  }
}

export const CreateLink = (path, currentLanguage = 'en') => {
  let link

  if (currentLanguage !== 'en') {
    link = `/${currentLanguage}/${path}` + trailingSlash(path)
  } else {
    link = `/${path}` + trailingSlash(path)
  }

  return link.replace('//', '/')
}
